import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/shape-8.png'


const _hoisted_1 = {
  class: "rounded-3 position-relative z-1 mb-4",
  style: {"background":"linear-gradient(92deg, #23272e 7.31%, #3f5272 97.89%)","padding":"60px 40px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<img src=\"" + _imports_0 + "\" class=\"position-absolute top-0 end-0\" alt=\"shape\"><div class=\"d-flex flex-wrap gap-2 align-items-center justify-content-between\"><div><h3 class=\"fs-28 text-white\">Manage Your NFT From One Place</h3><p style=\"color:#b1bbc8;\"> The world’s first and largest digital marketplace for discover, collect, sell and create your own NFTs. </p></div><button class=\"btn btn-primary py-2 p-4 position-relative z-1\" data-bs-toggle=\"modal\" data-bs-target=\"#exampleModal\"> Create NFT </button></div>", 2)
  ])))
}